module.exports = __webpack_public_path__ + "img/17.055f9f06.jpg";